import React, { forwardRef } from 'react';
import { Box } from '@chakra-ui/react';

const DotGrid = ({ color = 'currentColor' }) => (
  <Box
    as="span"
    display="grid"
    gridTemplateColumns="repeat(3, 4px)"
    gridTemplateRows="repeat(3, 4px)"
    gap="3px"
    w="18px"
    h="18px"
    color={color}
    aria-hidden
  >
    {Array.from({ length: 9 }).map((_, i) => (
      <Box key={i} as="span" w="4px" h="4px" borderRadius="full" bg="currentColor" opacity={0.88} />
    ))}
  </Box>
);

const AppLauncherButton = forwardRef(function AppLauncherButton(
  { isOpen, onToggle, muted = false, onClick: onClickFromParent, ...rest },
  ref,
) {
  return (
    <Box
      ref={ref}
      as="button"
      type="button"
      onClick={(e) => {
        onToggle(e);
        onClickFromParent?.(e);
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="40px"
      h="40px"
      borderRadius="full"
      borderWidth={0}
      cursor="pointer"
      bg={isOpen ? 'teal.50' : 'transparent'}
      color={isOpen ? 'teal.800' : muted ? 'gray.500' : 'gray.600'}
      transition="background 0.15s ease, color 0.15s ease, transform 0.12s ease"
      _hover={{
        bg: isOpen ? 'teal.100' : 'blackAlpha.50',
        color: isOpen ? 'teal.900' : 'gray.800',
      }}
      _active={{ transform: 'scale(0.96)' }}
      _focusVisible={{
        outline: '2px solid',
        outlineColor: 'teal.400',
        outlineOffset: '2px',
      }}
      aria-label="Open tools"
      aria-haspopup="dialog"
      aria-expanded={isOpen}
      sx={{ WebkitTapHighlightColor: 'transparent' }}
      {...rest}
    >
      <DotGrid />
    </Box>
  );
});

export default AppLauncherButton;
